import { RouteObject } from 'react-router-dom'
import NoteFoundPage from './Pages/NoteFoundPage'

const notFoundRoutes: RouteObject = {
	path: '*',
	element: <NoteFoundPage />,
}

export default notFoundRoutes
